import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, LinearProgress } from "@material-ui/core";
import { PasswordTextField } from "components";
import i18n from "../i18n";

// prop types
interface NewPasswordRequiredDialogProps {
    error: string | null,
    isLoading: boolean,
    showDialog: boolean,
    onClose: () => void,
    onCompleteNewPassword: (password: string, confirm: string) => void,
}

// new password required dialog
const NewPasswordRequiredDialog = ({ error, isLoading, showDialog, onClose, onCompleteNewPassword }: NewPasswordRequiredDialogProps) => {
    // ui state
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    // did hide hook -> clear input fields
    useEffect(() => {
        if (!showDialog) {
            setNewPassword("");
            setConfirmPassword("");
        }
    }, [showDialog]);

    // relevant errors
    const relevantErrors = ["passwordsDontMatch", "passwordPolicy"];

    // render
    return (
        <Dialog
            open={showDialog}
            onClose={onClose}
        >
            <DialogTitle>{i18n.newPasswordRequiredTitle}</DialogTitle>
            <DialogContent dividers>

                {/* new password required */}
                <DialogContentText>
                    {i18n.newPasswordRequiredDesc}
                </DialogContentText>

                {/* new password */}
                <PasswordTextField
                    autoFocus
                    disabled={isLoading}
                    error={relevantErrors.includes(error!)}
                    label={i18n.newPassword}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />

                {/* confirm password */}
                <PasswordTextField
                    disabled={isLoading}
                    error={relevantErrors.includes(error!)}
                    helperText={relevantErrors.includes(error!) && i18n.errors[error!]}
                    label={i18n.confirmPassword}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />

            </DialogContent>
            {isLoading && <LinearProgress />}
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
                <Button color="primary" onClick={() => onCompleteNewPassword(newPassword, confirmPassword)} disabled={isLoading}>
                    {i18n.ok}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewPasswordRequiredDialog;
